import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { applyPolyfills, defineCustomElements } from '@vanmossel-ui/components/loader';
import { App } from './App';
import { appConfiguration } from './configuration/app-configuration';
applyPolyfills().then(() => defineCustomElements(window));
const root = createRoot(appConfiguration.ROOT);
root.render(_jsx(App, {}));
